import { useEffect, useState } from "react";
import "./style.css"

function Login() {
    const [msgError, setMsgError] = useState(null);

    // Reconnection
    useEffect(() => {
        const user = localStorage.getItem('user_vanrah');
        const password = localStorage.getItem('password_vanrah');

        if (!user || !password) return

        const preLogin = async () => {
            await postLogin(user, password);
        }
        preLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const postLogin = async (user, password, setMessage) => {
        console.log(process.env);
        
        const req = await fetch(`${process.env.REACT_APP_API_URL}/vanrah/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user: user, password: password })
        });
        const res = await req.json();

        if (req.status !== 200) {
            localStorage.removeItem('user_vanrah');
            localStorage.removeItem('password_vanrah');
            localStorage.removeItem('token_vanrah');

            if (setMessage) setMessage(res.message);
            return
        }

        localStorage.setItem('user_vanrah', user);
        localStorage.setItem('password_vanrah', password);
        localStorage.setItem('token_vanrah', res.token);

        if (setMessage) window.location.reload();
    }

    const submitForm = async (e) => {
        e.preventDefault();
        setMsgError(null);

        const formData = new FormData(e.target);

        const user = formData.get("user");
        const password = formData.get("password");

        if (!user || !password) {
            setMsgError("Veuillez remplir tous les champs.");
            return;
        }

        await postLogin(user, password, setMsgError);
    }

    return !localStorage.getItem('token_vanrah') && (
        <div className="login">
            <form onSubmit={submitForm}>
                <span>Connexion</span>

                <div className="fields">
                    <div className="box">
                        <label htmlFor="user">Identifiant</label>
                        <input id="user" name="user" type="text" placeholder='MySpace' />
                    </div>

                    <div className="box">
                        <label htmlFor="password">Mot de passe :</label>
                        <input id="password" name="password" type="password" placeholder='************' />
                    </div>
                </div>

                {msgError !== '' &&
                    <p className='msg_error'>{msgError}</p>
                }

                <button type="submit" className='btn_submit'>Confirmer</button>
            </form>
        </div>
    )
}

export default Login;